import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-none border-2 border-black px-2 py-0.5 font-mono text-xs font-bold uppercase tracking-widest leading-none shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]",
  {
    variants: {
      variant: {
        pending: "bg-[var(--warning)] text-black",
        invoiced: "bg-[var(--success)] text-white",
        success: "bg-[var(--success)] text-white",
        error: "bg-[var(--error)] text-white",
        info: "bg-[var(--info)] text-white",
      },
    },
    defaultVariants: {
      variant: "pending",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
  VariantProps<typeof badgeVariants> { }

function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
